import React, { useMemo } from "react";
import { FaDownload } from "react-icons/fa";
import { GoPrimitiveDot } from "react-icons/go";
import { ButtonDelete, LongButton } from "../../components/common/Buttons";
import { exportDocument } from "../../helpers/Utils";
import TableUi from "../../components/Layout/TableUI";
import { formatDateTime } from "../../utils/date";
import ShipmentTypeRender from "./ShipmentTypeRender";
import { useDispatch } from "react-redux";
import { removeShipmentBeforeCalled } from "../../redux/Actions/shipmentsAction";
import AntdConfirm from "../../helpers/AntdConfirm";
import { colors } from "../../utils/colors";

function TableColumnShipment({ onModalAction, ...props }) {
  const dispatch = useDispatch();
  const { item } = props;

  const shipment_documents = useMemo(() => {
    return props.item.shipment_documents.filter(
      (d) => d.identifier == "labels"
    );
  }, []);

  // Konsoliduotas atsiemimas
  const combined_shipment = props.item.manifest?.to_office && !!props.item.manifest?.store;

  return (
    <TableUi.tr className="align-middle tableColumn">
      <TableUi.td className={"p-left position-relative"}>
        {combined_shipment && (
            <div
              className="position-absolute"
              style={{
                background: `linear-gradient(90deg, ${colors["purple"]} 0%, rgba(134, 120, 171, 0) 100%)`,
                width: 5,
                top: 0,
                bottom: 0,
                left: 0,
              }}
            />
          )}
        <ShipmentTypeRender value={props.item.shipment_type} />
        {combined_shipment && (
          <LongButton
            className="text-xss text-white mt-2"
            style={{
              width: 100,
              backgroundColor: colors["purple"],
              fontSize: 9,
              height: "auto",
            }}
            text={"Combined shipment"}
          />
        )}
      </TableUi.td>
      <TableUi.td>
        <GoPrimitiveDot
          style={props.item.printed ? { color: "green" } : { color: "red" }}
        />
      </TableUi.td>
      <TableUi.td>
        <GoPrimitiveDot
          style={
            props.item.courier_called ? { color: "green" } : { color: "red" }
          }
        />
      </TableUi.td>
      <TableUi.td>{formatDateTime(item.created_at)}</TableUi.td>
      <TableUi.td>
        {item.records.map((record) => {
          if (record.type == "service") {
            return (
              <a
                className="text-primary"
                onClick={() =>
                  onModalAction("Service", {
                    id: record.record.id,
                    custom: record.record.id,
                  })
                }
              >
                {record.record.number}
              </a>
            );
          }
          if (record.type == "order") {
            return (
              <a
                className="text-primary"
                onClick={() =>
                  onModalAction("Order", {
                    id: record.record.id,
                    custom: record.record.id_order,
                  })
                }
              >
                {record.record.id_order}
              </a>
            );
          }
          if (record.type == "fake_order") {
            return (
              <a
                className="text-primary"
                onClick={() =>
                  onModalAction("FakeOrder", {
                    id: record.record.id,
                    custom: "FO" + record.record.id,
                  })
                }
              >
                {"FO" + record.record.id}
              </a>
            );
          }

          return "Mistake";
        })}
      </TableUi.td>
      <TableUi.td>{props.item.pickup_address.code}</TableUi.td>
      <TableUi.td>{props.item.dpd_service}</TableUi.td>
      <TableUi.td>{props.item.packets}</TableUi.td>
      <TableUi.td>{props.item.weight} </TableUi.td>
      <TableUi.td>{props.item.shipment_address.name}</TableUi.td>
      <TableUi.td>
        {props.item.shipment_address?.country &&
          `${props.item.shipment_address.country.en_name}, `}
        {props.item.shipment_address.address}
      </TableUi.td>
      <TableUi.td>{props.item.shipment_address.comment}</TableUi.td>
      <TableUi.td>
        {item.courier_trackings.length > 0 ? (
          item.courier_trackings.map((courier_tracking) => (
            <span key={courier_tracking.number}>
              <a href={courier_tracking.url} target="_blank">
                {courier_tracking.number}
              </a>
              <br />
            </span>
          ))
        ) : item.external_order_number ? (
          <div className="text-danger" key={item.external_order_number}>
            EN: {item.external_order_number}
          </div>
        ) : null}
      </TableUi.td>
      <TableUi.td className={"text-nowrap"}>
        {shipment_documents.length > 0 ? (
          <button
            className="btn btn-primary btn-sm"
            onClick={() => {
              exportDocument(
                `/api/v1/order_shipments/${props.item.id}/download`,
                `order_shipment_${props.item.id}.pdf`,
                "POST"
              );
            }}
          >
            <FaDownload className="mr-2" title="Download" />
            Download
          </button>
        ) : null}
      </TableUi.td>
      <TableUi.td>
        {!!props.item.manifest_closed_at ? (
          <span className="text-danger text-xs">M. closed</span>
        ) : (
          props.item.courier_called == false &&
          item.records
            .filter((record) => record.type !== "service")
            .map((record) => (
              <ButtonDelete
                key={record.record.id}
                onDelete={() =>
                  AntdConfirm({
                    onOk: () =>
                      dispatch(
                        removeShipmentBeforeCalled(
                          props.item.id,
                          record.record.id,
                          record.type == "fake_order" ? "FakeOrders" : "dpd"
                        )
                      ),
                  })
                }
              />
            ))
        )}
      </TableUi.td>
    </TableUi.tr>
  );
}

export default TableColumnShipment;
